<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mb-4 pb-2 pt-2">Create HHA </h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-12">
				<form @submit.prevent="onSubmit">
					<label class="mb-2 h5 green">1. PERSONAL INFO</label>
					<div class="lightgray-content p-3 rounded mb-2">
						<div class="row">
							<div class="col-12 col-lg-4 col-xl-3">
								<div class="form-group input-content">
									<label>IMAGE</label>
									<vue-dropzone id="dropzone"  class="mb-3 rounded" :options="dropzoneOptions"
									@vdropzone-removed-file="removeFile"
										@vdropzone-thumbnail="setImg"></vue-dropzone>
								</div>
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<!--
								<div class="form-group input-content">
									<label>Email</label>
									<input placeholder="Email" type="text" v-model="provider_data.email" class="form-control" v-validate="'email'" name="email">
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
							-->
								<div class="form-group input-content">
									<label>First name</label>
									<input placeholder="First name" type="text" v-model="provider_data.first_name" class="form-control" v-validate="'required'" name="first_name">
									<span class="input-error-msg">{{ errors.first('first_name') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Last name</label>
									<input placeholder="Last name" type="text" v-model="provider_data.last_name" class="form-control" v-validate="'required'" name="last_name">
									<span class="input-error-msg">{{ errors.first('last_name') }}</span>
								</div>
								<!-- <div class="form-group input-content">
									<label>Gender</label>
									<v-select class="mb-2"  :searchable="false"  :options="[{ 'value' : '-', 'label' : '-'}, { 'value' : 'Male', 'label' : 'Male' }, { 'value' : 'Female', 'label' : 'Female' }]" v-model="provider_data.gender">
									</v-select>
								</div> -->
							</div><!--col-->
							<div class="col-12 col-lg-4">
							<!--	<div class="form-group input-content">
									 <label>Birthday</label>
										<div class="row ml-0">
											<date-picker placeholder="Birthday" class="date_picker_new" v-model="provider_data.dob" :range="false" :format="'MM-DD-YYYY'" 
											:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
											:valueType="'YYYY-MM-DD'">
											</date-picker>
										</div>
									<span class="input-error-msg">{{ errors.first('dob') }}</span>
								</div> -->
								
								<div class="form-group input-content">
									
									<div class="row">
										<div class="col-5">
											<label>Country code</label>
											<v-select class="mb-2" name="country_code" :searchable="true" :options="country_codes" v-model="provider_data.country_code"
													v-validate="'required'">
											</v-select>
											<span class="input-error-msg">{{ errors.first('country_code') }}</span>
										</div>
										<div class="col-7">
											<label>Mobile number</label>
											<input placeholder="Mobile number" type="text" v-model="provider_data.phone" class="form-control" name="phone"
												v-validate="'required|min:8|max:10'">
											<span class="input-error-msg">{{ errors.first('phone') }}</span>
											<span class="input-error-msg" v-if="user_active">This Phone Number Exist In the System</span>
										</div>
									</div>
									
								</div>
								<div class="form-group input-content">
									<label>Preferred language</label>
									<multiselect v-model="provider_data.language" 
									label="value"
									:options="preferred_languages"></multiselect>
								</div>

								<!--
								<div class="form-group input-content">
									<label>SSN</label>
									<input placeholder="SSN" type="text" v-model="provider_data.ssn" 
											class="form-control" v-validate="'required|numeric|length:9|ssn_unique'" name="ssn">
									<span class="input-error-msg">{{ errors.first('ssn') }}</span>
								</div>
							-->
							</div><!--col-->
						</div><!--row-->
						<div class="row">
							<div class="col">
								<label class="mb-2 h6 green">TAGS</label>
								<tags :entity_str="'App\\Models\\Provider'" ref="tags"></tags>
							</div><!-- col -->
						</div><!-- row -->
					</div>

					<div class="text-right mt-2 mb-5">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div><!--col-->
		</div><!--row-->
	</div>
</template>

<script>
import { API_BASE } from '../../../config'
export default {
	data : function(){
		return {
			provider_data : {
				ssn : '',
				first_name : '',
				last_name : '',
				// dob: '',
				email : '',
				// gender: '-',
				language: '',
				phone: '',
				image : null,
				country_code : {
					label : '+1',
					value : '+1',
					name : 'United States'
				}
			},
			preferred_languages : [],
			dropzoneOptions: {
				url : API_BASE,
				thumbnailWidth: 50,
				maxFilesize: 4,
				maxFiles : 1,
				addRemoveLinks : true,
				headers : {
					'Autrollization' : localStorage.getItem('token')
				},
				autoProcessQueue : false
		    },
			user_active:false,
		    country_codes : []
		}
	},
	watch: {
		'provider_data.phone': function(val){
			if(val != '' || val != null){
				var removedText = val.replace(/\D+/g, '');
				this.provider_data.phone = removedText
			}
			if(this.user_active === true){
				this.user_active = false
			}	
		}
	},
	created : function(){
		this.getCountries();
		this.getPreferredLanguages();
	},
	methods : {
		getCountries : function(){
			this.$store.dispatch('getCountries', {}).then((res) => {
			
				this.country_codes = res.data.data;
			}).catch((error) =>{	
				console.log(error);
			});
		},
		onSubmit : async function(){
		var params = {
			filters:{
					search : this.provider_data.phone
				}
			}
			this.$store.dispatch('getProvidersCountV2', params).then((res)=>{
				console.log(res.data)
				if(res.data != 1){
					if(this.user_active == false){
					this.$validator.validateAll().then((result) => {
						if(result){
						
							// this.provider_data.gender = this.provider_data.gender.value;

							this.provider_data.groups = this.$refs.tags.groups;
							this.provider_data.country_code = this.provider_data.country_code.value;
							if(this.provider_data.language){
								this.provider_data.language = this.provider_data.language.key
							}
							this.$store.dispatch('createProvider', this.provider_data).then((res) => {

								//upload the image
								this.$router.push({ name : 'admin.providers.index' });
							}).catch((error) => {
								
						});
					}
				});
			}

			}else{
				this.user_active = true
			}
				
			}).catch((error) =>{
				console.log(error)
			})
		
		


		},
		setImg : function(file, dataUrl){
			this.provider_data.image = dataUrl;
		},
		removeFile: function(){
			this.provider_data.image = null
		},
		getPreferredLanguages : function(){
			this.preferred_languages = []
			var params = { filters:{available_for_users: 1} };
			this.$store.dispatch('getLanguages', params).then((res) => {
				console.log(res.data.data)
				for(let i in res.data.data){
					if(this.provider_data.language == res.data.data[i][0].code_2){
						this.provider_data.language = {key:res.data.data[i][0].code_2, value:res.data.data[i][0].name}
					}
					this.preferred_languages.push({key:res.data.data[i][0].code_2, value:res.data.data[i][0].name})
				}
			}).catch((error) => {
				console.log(error);
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/providers/AdminProviderCreateComponent.vue